import React, { useEffect, useCallback } from "react";
import { setTokenToClient } from "./common/axiosClient";
import { useDispatch, useSelector } from "./store/Store";
import { selectToken, setAuth, setUserDetail } from "./store/authSlice";
import { getMemberDetail } from "./services/accoutApi";

function AuthBoundary() {
  console.log("sss");
  const refreshToken = sessionStorage.getItem("ssuser");
  if (refreshToken) {
    try {
      // JSON 파싱
      const parsedToken = JSON.parse(refreshToken);

      // Access token 가져오기
      const accessToken = parsedToken.accessToken;
      if (accessToken) {
        // Axios 클라이언트에 토큰 설정
        setTokenToClient(accessToken);

        // 사용자 정보를 가져와 Redux 상태 업데이트
        // getMemberDetail()
        //   .then((response) => {
        //     dispatch(setUserDetail(response.data)); // 사용자 정보 저장
        //     dispatch(setAuth(true)); // 인증 상태 설정
        //   })
        //   .catch((error) => {
        //     console.error("Failed to fetch user detail:", error);
        //     dispatch(setAuth(false)); // 인증 상태 해제
        //   });
      } else {
        console.error("No accessToken found in refreshToken.");
      }
    } catch (error) {
      console.error("Failed to parse refreshToken:", error);
    }
  } else {
    console.log("No refreshToken found in sessionStorage.");
  }

  return <></>;
}

export default AuthBoundary;
